var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_973_4152)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 33,
    height: 33,
    rx: 4,
    fill: "#34B8A7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_973_4152)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 24.1875C21.75 24.3698 21.6776 24.5447 21.5486 24.6736C21.4197 24.8026 21.2448 24.875 21.0625 24.875H10.0625C9.88016 24.875 9.7053 24.8026 9.57636 24.6736C9.44743 24.5447 9.375 24.3698 9.375 24.1875V11.8125C9.375 11.6302 9.44743 11.4553 9.57636 11.3264C9.7053 11.1974 9.88016 11.125 10.0625 11.125H21.0625C21.2448 11.125 21.4197 11.1974 21.5486 11.3264C21.6776 11.4553 21.75 11.6302 21.75 11.8125V14.5625C21.75 14.7448 21.8224 14.9197 21.9514 15.0486C22.0803 15.1776 22.2552 15.25 22.4375 15.25C22.6198 15.25 22.7947 15.1776 22.9236 15.0486C23.0526 14.9197 23.125 14.7448 23.125 14.5625V11.8125C23.125 11.2655 22.9077 10.7409 22.5209 10.3541C22.1341 9.9673 21.6095 9.75 21.0625 9.75H10.0625C9.51549 9.75 8.99089 9.9673 8.60409 10.3541C8.2173 10.7409 8 11.2655 8 11.8125V24.1875C8 24.7345 8.2173 25.2591 8.60409 25.6459C8.99089 26.0327 9.51549 26.25 10.0625 26.25H21.0625C21.6095 26.25 22.1341 26.0327 22.5209 25.6459C22.9077 25.2591 23.125 24.7345 23.125 24.1875V21.4375C23.125 21.2552 23.0526 21.0803 22.9236 20.9514C22.7947 20.8224 22.6198 20.75 22.4375 20.75C22.2552 20.75 22.0803 20.8224 21.9514 20.9514C21.8224 21.0803 21.75 21.2552 21.75 21.4375V24.1875Z",
    fill: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7992 18.4868C29.8633 18.4229 29.9141 18.347 29.9487 18.2635C29.9834 18.18 30.0012 18.0904 30.0012 18C30.0012 17.9096 29.9834 17.82 29.9487 17.7365C29.9141 17.653 29.8633 17.5771 29.7992 17.5133L25.6742 13.3883C25.5452 13.2592 25.3701 13.1866 25.1875 13.1866C25.0049 13.1866 24.8298 13.2592 24.7008 13.3883C24.5717 13.5174 24.4991 13.6924 24.4991 13.875C24.4991 14.0576 24.5717 14.2327 24.7008 14.3618L27.6529 17.3125H15.5625C15.3802 17.3125 15.2053 17.3849 15.0764 17.5139C14.9474 17.6428 14.875 17.8177 14.875 18C14.875 18.1824 14.9474 18.3572 15.0764 18.4862C15.2053 18.6151 15.3802 18.6875 15.5625 18.6875H27.6529L24.7008 21.6383C24.5717 21.7674 24.4991 21.9424 24.4991 22.125C24.4991 22.3076 24.5717 22.4827 24.7008 22.6118C24.8298 22.7409 25.0049 22.8134 25.1875 22.8134C25.3701 22.8134 25.5452 22.7409 25.6742 22.6118L29.7992 18.4868Z",
    fill: "#FDFDFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_973_4152",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_973_4152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_973_4152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_973_4152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.602df9549eeb0d66771c8801c5409cf8.svg";
export { ForwardRef as ReactComponent };